import { useSyncExternalStore } from 'react';

import { modalityStore, type Modality } from '../utils/modality.js';

/**
 * Hook to subscribe to the current input modality and only re-render the component when it changes.
 *
 * @returns The current input modality
 * @internal
 */
export function useModality(): Modality {
  const modality = useSyncExternalStore(
    modalityStore.subscribe,
    modalityStore.getState,
  );
  return modality;
}
